import { render } from "./PostView.vue?vue&type=template&id=dfd4f44e&ts=true"
import script from "./PostView.vue?vue&type=script&lang=ts"
export * from "./PostView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/taiko/Documents/irdtechbook_cloudflare/test/pages-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__